import { useRef } from "react";
import HomeNav from "@/components/HomeNav";
import HomeHero from "@/components/HomeHero";
import TransformationThesis from "@/components/TransformationThesis";
import Capabilities from "@/components/Capabilities";
import HomeSelectedWork from "@/components/HomeSelectedWork";
import DeliveryMethod from "@/components/DeliveryMethod";
import Firm from "@/components/Firm";
import HomeClosingCTA from "@/components/HomeClosingCTA";
import HomeFooter from "@/components/HomeFooter";
import useEditorialMotion from "@/hooks/useEditorialMotion";
import "@/homepage.css";

export default function Home() {
  const siteRef = useRef(null);
  useEditorialMotion(siteRef);

  return (
    <div className="av-site" ref={siteRef}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <HomeNav />
      <main id="main-content">
        <HomeHero />
        <TransformationThesis />
        <Capabilities />
        <HomeSelectedWork />
        <DeliveryMethod />
        <Firm />
        <HomeClosingCTA />
      </main>
      <HomeFooter />
    </div>
  );
}
